import { ReactElement } from 'react';
import { TIconProps } from '@/common/components/Icons/Icon';
import { useIsInFlowLayout } from '@/common/layouts/FlowLayout/FlowLayout.utils';
import { Route, usePathname, useRouter } from 'expo-router';
import { TabBarTrigger } from '../TabBar/TabBar';

export function TabBarItem({
  href,
  label,
  icon,
  exact,
  notification,
}: TNavigationItemProps) {
  const router = useRouter();
  const pathname = usePathname();
  const isFocused = exact ? pathname === href : pathname.startsWith(href);
  const isInFlow = useIsInFlowLayout();

  return (
    <TabBarTrigger
      href={href}
      label={label}
      icon={icon}
      notification={notification}
      isFocused={isFocused}
      onPress={(evt) => {
        evt.preventDefault();
        if (isInFlow) {
          router.dismissAll();
          router.replace(href as Route);
        } else {
          router.push(href as Route);
        }
      }}
    />
  );
}

export type TNavigationItemProps = {
  href: string;
  label: string;
  icon: ReactElement<TIconProps>;
  exact?: boolean;
  notification?: boolean;
};
